import { createAsyncThunk } from "@reduxjs/toolkit";
import type {
  EmailConfirmationRequest,
  EmailConfirmationResponse,
  FacebookSignupRequest,
  FacebookSignupResponse,
  ForgotPasswordRequest,
  GoogleSignupRequest,
  GoogleSignupResponse,
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  ResendEmailRequest,
  ResendEmailResponse,
  ResetPasswordRequest,
  SignUpRequest,
  SignUpResponse,
  SingpassSignupResponse,
  SingpassSignUpVerificationResponse,
  SingpassSignUpVerificationRequest,
  SingpassSignupRequest,
  GetSingpassAuthUrlRequest,
  GetSingpassAuthUrlResponse,
  ForgotPasswordResponse,
} from "../ts";
import { authAPI } from "../api";
import { handleErrors, type ApiError } from "../../../api/errorUtils";

export const SignUpThunk = createAsyncThunk<SignUpResponse, SignUpRequest>(
  "auth/signup_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await authAPI.signup(requestData);
      return data;
    } catch (e: unknown) {
      return handleErrors(e as ApiError, thunkAPI);
    }
  },
);

export const SignUpGoogleThunk = createAsyncThunk<
  GoogleSignupResponse,
  GoogleSignupRequest
>("auth/signup/google_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.signUpGoogle(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const SignUpFacebookThunk = createAsyncThunk<
  FacebookSignupResponse,
  FacebookSignupRequest
>("auth/signup/facebook_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.signUpFacebook(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const ResendEmailThunk = createAsyncThunk<
  ResendEmailResponse,
  ResendEmailRequest
>("auth/resend_email_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.resendEmail(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const EmailConfirmationThunk = createAsyncThunk<
  EmailConfirmationResponse,
  EmailConfirmationRequest
>("auth/email_confirmation_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.emailConfirmation(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});


export const LoginThunk = createAsyncThunk<LoginResponse, LoginRequest>(
  "auth/login_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await authAPI.login(requestData);
      return data;
    } catch (e: unknown) {
      return handleErrors(e as ApiError, thunkAPI);
    }
  },
);

export const LogoutThunk = createAsyncThunk<null, LogoutRequest>(
  "auth/logout_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await authAPI.logout(requestData);
      return data;
    } catch (e: unknown) {
      return handleErrors(e as ApiError, thunkAPI);
    }
  },
);

export const ForgotPasswordThunk = createAsyncThunk<
  ForgotPasswordResponse,
  ForgotPasswordRequest
>("auth/forgot_password_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.forgotPass(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const ResetPasswordThunk = createAsyncThunk<null, ResetPasswordRequest>(
  "auth/reset_password_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await authAPI.resetPassword(requestData);
      return data;
    } catch (e: unknown) {
      return handleErrors(e as ApiError, thunkAPI);
    }
  },
);

export const GetSingpassAuthUrlThunk = createAsyncThunk<
  GetSingpassAuthUrlResponse,
  GetSingpassAuthUrlRequest
>("auth/signup/singpass_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.singpassOAuthUrl(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const SignUpSingpassThunk = createAsyncThunk<
  SingpassSignupResponse,
  SingpassSignupRequest
>("auth/signup/singpass_myinfo_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.signUpSingpass(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const SignUpVerificationSingpassThunk = createAsyncThunk<
  SingpassSignUpVerificationResponse,
  SingpassSignUpVerificationRequest
>("auth/signup/singpass_verification_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await authAPI.signUpVerificationSingpass(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});



const authThunks = {
  SignUpThunk,
  SignUpGoogleThunk,
  SignUpFacebookThunk,
  ResendEmailThunk,
  EmailConfirmationThunk,
  LoginThunk,
  LogoutThunk,
  ForgotPasswordThunk,
  ResetPasswordThunk,
  GetSingpassAuthUrlThunk,
  SignUpSingpassThunk,
  SignUpVerificationSingpassThunk,
};
export default authThunks;
